import styled from 'styled-components';

import { Card } from '@components/card';
import { HtmlContent } from '@components/html-content';
import { Modal, useModal } from '@components/modal';
import { Separator } from '@components/separator';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { useScopedTranslate } from '@locale/translate';
import { pxToRem } from '@utils/converters';

export const usePreviewEmailModal = () => useModal(PreviewEmailModal, { variant: 'LARGE' });

type PreviewEmailModalProps = {
  subject: string;
  content: string;
};

const PreviewEmailModal = ({ subject, content }: PreviewEmailModalProps) => {
  const { t } = useScopedTranslate(locale);
  return (
    <Modal>
      <Modal.SimpleHeader title={t('title')} />
      <ContentContainer>
        <Modal.Content>
          <Stack space={8}>
            <Stack space={2}>
              <Stack space={1}>
                <EmailItem infoText={t('from')} text="noreply@50skills.com" />
                <Separator />
              </Stack>
              <Stack space={1}>
                <EmailItem infoText={t('to')} text={'{{ applicant_email }}'} />
                <Separator />
              </Stack>
              <Stack space={1}>
                <EmailItem infoText={t('subject')} text={subject} />
              </Stack>
            </Stack>
            <Card spaceY={10} spaceX={16}>
              <HtmlContent html={content} />
            </Card>
          </Stack>
        </Modal.Content>
      </ContentContainer>
    </Modal>
  );
};

const EmailItem = ({ text, infoText }: { text: string; infoText: string }) => {
  return (
    <Stack space={4} align="center" orientation="horizontal">
      <StyledText color="textSecondary" font="semibold14" text={infoText} capitalize />
      <Text font="regular14" color="textSecondary" text={text} />
    </Stack>
  );
};

const ContentContainer = styled.div({
  overflowY: 'auto',
  marginTop: pxToRem(24),
});

const StyledText = styled(Text)({
  width: pxToRem(120),
});

const locale = {
  en: {
    title: 'Email preview',
    from: 'From',
    to: 'To',
    subject: 'Subject',
  },
  is: {
    title: 'Forskoða póst',
    from: 'Frá',
    to: 'Til',
    subject: 'Efnislína',
  },
};
